import React, { useState } from "react"
import { useSelector, useDispatch } from "react-redux"
import { ConfigContainer, Loading, SampleTable } from "components"
import { plannableSamples, message, samples, analyses } from "state_management"
import useT from "utils/hooks/useT"
import { Button } from "react-bootstrap"
import { ConfirmDialog } from "components"
import { Container } from "components/Form"
import { FiInfo } from "react-icons/fi"

// Used as a popup when adding new samples to a planned analysis
export default function PlannableSamples({ analysisId, handler }) {
  const dispatch = useDispatch()
  const { t } = useT("messages")
  const { t: tc } = useT("common")

  const sampleData = useSelector((state) => state.plannableSamples[analysisId] || null)
  const [checkedSamples, setCheckedSamples] = useState([])
  const [plannedSamplesConfirmDialog, setPlannedSamplesConfirmDialog] = useState(false)
  const [showPlannedSamples, setShowPlannedSamples] = useState(false)
  const hasExclusiveSample = showPlannedSamples ?
    sampleData?.samples?.plannedSamples.some(sample => sample.exclusive === true) :
    sampleData?.samples?.unplannedSamples.some(sample => sample.exclusive === true)
  
  if (!sampleData) {
    dispatch(plannableSamples.fetch(analysisId)).catch((e) => {
      dispatch(plannableSamples.needsRefresh(analysisId))
    })
  }

  if (!sampleData || sampleData.isLoading) {
    return <Loading />
  } else if(sampleData.needsRefresh) {
    dispatch(message.warning(t("adhoc.analysisUpdatedByAnotherUser")))
    return handler()
  }

  return (
    <>
      {plannedSamplesConfirmDialog && (
        <ConfirmDialog
          onCancel={() => setPlannedSamplesConfirmDialog(false)}
          onConfirm={() => {
            setShowPlannedSamples(true)
            setPlannedSamplesConfirmDialog(false)
          }}
        >
          <Container>
            <div>
              <FiInfo title={tc("confirmShowPlannedSamplesInfo")} />
            </div>
            <h4>{tc("confirmShowPlannedSamplesQuestion")}</h4>
          </Container>
        </ConfirmDialog>
      )}
      <ConfigContainer
        submitHandler={() => {
          // If no checkboxes are clicked
          if (checkedSamples.length === 0) {
            dispatch(message.warning(t("adhoc.noCheckboxesSelected")))
          } else {
            dispatch(samples.assignSamples(analysisId,checkedSamples)).then(
              () => dispatch(plannableSamples.fetch(analysisId)).then (() => {
                dispatch(analyses.fetchPlanned())
              })
            )
            handler()
          }
        }}
        cancelHandler={() => {
          handler()
        }}
      >
        <div className="radio-buttons-add-samples">
          <Button
          className="buttonAnalysis"
            variant={showPlannedSamples ? "light" : "primary"}
            onClick={() => {
              setShowPlannedSamples(false)
            }}
          >
            {tc("unplanned")}
          </Button>
          <Button
          className="buttonProject"
            variant={showPlannedSamples ? "primary" : "light"}
            onClick={() => {
              setPlannedSamplesConfirmDialog(true)
            }}
          >
            {tc("planned")}
          </Button>
        </div>
        { /* This should show planned samples when "showPlannedSamples" is true */}
        <div className="sample-table-planned-main-container">
          <SampleTable
            popupSamples={showPlannedSamples ? sampleData.samples.plannedSamples : sampleData.samples.unplannedSamples}
            checkedSamples={checkedSamples}
            setCheckedSamples={setCheckedSamples}
            analysisId={analysisId}
          />
        </div>
        {hasExclusiveSample && (
          <div className="explanation-text">
            {tc("exclusiveSampleIndicator")}
          </div>
        )}
      </ConfigContainer>
    </>
  )
}
